import { render, staticRenderFns } from "./SetHeightCTD.vue?vue&type=template&id=2dc91ae3&scoped=true&"
import script from "./SetHeightCTD.vue?vue&type=script&lang=js&"
export * from "./SetHeightCTD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc91ae3",
  null
  
)

export default component.exports